<script>
    import {createEventDispatcher} from "svelte"
    import {onMount} from "svelte"
    import {XYZtoRGB} from "./color.js"

    const dispatch = createEventDispatcher()

    export let points = {}

    $: {
        for (let [_, point] of Object.entries(points)) {
            if (point.X && point.Z) {
                point.x = point.X / (point.X + point.Y + point.Z)
                point.y = point.Y / (point.X + point.Y + point.Z)
            }
        }
    }

    let rects = []
    let rectStep = 0.01
    {
        rects = []
        for (let x = rectStep / 2; x < 1; x += rectStep) {
            for (let y = rectStep / 2; y < 1; y += rectStep) {
                if (x + y > 1.2) {
                    continue
                }
                let Y = 0.8
                let X = (Y / y) * x
                let Z = (Y / y) * (1 - x - y)

                let rgbValues = XYZtoRGB(X, Y, Z)
                let rgb = `rgb(${rgbValues.r * 255}, ${rgbValues.g * 255}, ${
                    rgbValues.b * 255
                })`
                rects.push({
                    x: x * 100 - (rectStep / 2) * 100,
                    y: (1 - y) * 100 - (rectStep / 2) * 100,
                    width: rectStep * 111,
                    height: rectStep * 111,
                    fill: rgb,
                })
            }
        }
    }

    function handleMousemove(event) {
        if (mousedown) {
            if (event.touches) {
                event.clientX = event.touches[0].pageX
                event.clientY = event.touches[0].pageY
            }
            let loc = cursorPoint(event)
            dispatch("click", {x: loc.x / 100, y: 1 - loc.y / 100})
        }
    }

    let mousedown = false
    function handleMousedown(event) {
        mousedown = true
        let loc = cursorPoint(event)
        dispatch("click", {x: loc.x / 100, y: 1 - loc.y / 100})
    }
    function handleMouseup(event) {
        mousedown = false
    }

    var pt
    var svg
    onMount(async () => {
        // Create an SVGPoint for future math
        pt = svg.createSVGPoint()
    })

    function cursorPoint(evt) {
        pt.x = evt.clientX
        pt.y = evt.clientY
        return pt.matrixTransform(svg.getScreenCTM().inverse())
    }
</script>

<main>
    <svg
        bind:this={svg}
        on:mousedown={handleMousedown}
        on:mouseup={handleMouseup}
        on:mousemove={handleMousemove}
        on:touchstart={handleMousedown}
        on:touchend={handleMouseup}
        on:touchmove={handleMousemove}
        viewBox="-10 -10 120 120"
    >
        <!--<rect x="-10" y="-10" width="120" height="120" fill={rgb} />-->

        <text x="-8" y="108" font-size="5" fill="white"> 0% </text>
        <text x="90" y="108" font-size="5" fill="white"> 100% x </text>
        <text x="-10" y="-5" font-size="5" fill="white"> 100% y </text>

        {#each rects as r}
            <rect
                x={r.x}
                y={r.y}
                width={r.width}
                height={r.height}
                fill={r.fill}
                stroke="none"
            />
        {/each}

        {#each Object.entries(points) as [label, point]}
            <circle
                cx={100 * point.x}
                cy={100 * (1 - point.y)}
                r={label === "light" || label.substring(0, 4) === "sRGB"
                    ? 1
                    : 0.5}
                fill="black"
            />
            <text
                x={100 * point.x + 1}
                y={100 * (1 - point.y) - 1}
                font-size="3"
                fill="black"
            >
                {label}
            </text>
        {/each}
    </svg>
</main>

<style>
    svg {
        width: 40em;
    }
</style>
